var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"technology-icon"},[_c('i',{class:_vm.technology.deviconClasses}),(_vm.technology.name !== undefined)?_c('div',[_c('h4',{staticClass:"floating-low"},[_vm._v(_vm._s(_vm.technology.name))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }